export class UserAuctionAuthorizationStatusRequest{
    public userId!:string;
    public businessId!:string;
    public purchaseAgreementRequired:boolean = false;
    public auctionId!:number;
    public scheduleSequenceNo?:number;
    public propertyId!:number;
}